module.exports = __webpack_public_path__ + "assets/10bis-66029c.svg";